import { Directive, ElementRef, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { GoogleMapsService } from '@df/module-google-maps/google-maps.service';

@Directive()
export abstract class AbstractGoogleMaps implements OnInit {
    /**
     * Map instance
     * @type {google.maps.Map}
     */
    protected googleMap?: google.maps.Map;

    /**
     * Google maps api (window.google.map)
     * @type { ? }
     */
    protected googleMapApi: any;

    /**
     * Is initiated flag
     * @type {Boolean}
     */
    protected initiated = false;

    constructor(
        public element: ElementRef,
        readonly app: App,
        protected timeoutService: TimeoutService,
        private googleMapsService: GoogleMapsService
    ) {}

    ngOnInit() {
        if (!this.app.isPlatformBrowser) {
            return;
        }
        this.googleMapsService.load().then(() => {
            this.onReady();
        });
    }

    onReady() {
        if (!this.initiated) {
            const google = window['google'];
            if (google) {
                this.googleMapApi = google.maps;
                if (this.googleMapApi) {
                    this.initiated = true;
                    this.onInit();
                }
            }
        }
    }

    protected abstract onInit(): any | false;
}
